export default "__VITE_ASSET__DRC9TcqD__"